import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function NotificationModal({
    show,
    onClose,
    onSubmit,
    initialData,
    isSendMode,
    isLoading
}) {
    const [formData, setFormData] = useState({
        text: "",
        sort: 1,
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (show) {
            if (initialData && !isSendMode) {
                // Edit Mode
                setFormData({
                    text: initialData.text || "",
                    sort: initialData.sort || 1,
                });
            } else {
                // Create or Send Mode (Start empty)
                setFormData({
                    text: "",
                    sort: 1,
                });
            }
            setErrors({});
        }
    }, [show, initialData, isSendMode]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.text.trim()) {
            newErrors.text = "Notification text is required.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            onSubmit(formData);
        }
    };

    const getModalTitle = () => {
        if (isSendMode) return "Send Push Notification";
        return initialData ? "Edit Notification" : "Add Notification";
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton className="bg-light">
                <Modal.Title>{getModalTitle()}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit} noValidate>
                <Modal.Body className="p-4">
                    <div className="mb-3">
                        <Form.Label className="fw-bold">
                            Notification Text <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={formData.text}
                            onChange={(e) => {
                                setFormData({ ...formData, text: e.target.value });
                                if (errors.text) setErrors({ ...errors, text: null });
                            }}
                            isInvalid={!!errors.text}
                            placeholder="Enter notification message..."
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.text}
                        </Form.Control.Feedback>
                    </div>

                    {/* Hide Sort Order if we are just Sending immediately */}
                    {!isSendMode && (
                        <div className="mb-3">
                            <Form.Label className="fw-bold">Sort Order</Form.Label>
                            <Form.Control
                                type="number"
                                value={formData.sort}
                                onChange={(e) => setFormData({ ...formData, sort: Number(e.target.value) })}
                                min="0"
                            />
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                {isSendMode ? "Sending..." : "Saving..."}
                            </>
                        ) : (
                            <>
                                <i className={`fas ${isSendMode ? "fa-paper-plane" : "fa-save"} me-2`}></i>
                                {isSendMode ? "Send Now" : "Save"}
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}